<template>
  <Header />
  <Menu />
  <router-view />
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';

export default {
  components: {
    Header,
    Menu,
  },
};
</script>

<style>
@import './styles/ldbtn.css';
@import './styles/loader.css';
@import './styles/app.css';
@import './styles/table.css';
@import './styles/tippy.css';
@import './styles/toaster.css';
</style>
